/*
 This file is part of GNU Taler
 (C) 2022 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import { h, VNode } from "preact";
import { useTranslationContext } from "../context/translation.js";

export function Loading(): VNode {
  const { i18n } = useTranslationContext();
  return (
    <div
      class="columns is-centered is-vcentered"
      role="status"
      aria-live="polite"
      style={{
        width: "100%",
        height: "200px",
        display: "flex",
        margin: "auto",
        justifyContent: "center",
      }}
    >
      <Spinner />
      <span class="sr-only">
        <i18n.Translate>Loading</i18n.Translate>
      </span>
    </div>
  );
}

function Spinner(): VNode {
  return (
    <svg
      aria-hidden="true"
      class="m-auto h-8 w-8 animate-spin text-gray-500"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        stroke-width="3"
        opacity="0.25"
      />
      <path
        d="M21 12a9 9 0 00-9-9"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  );
}
